import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import React from "react";
import { t } from "ttag";
import { IQueuesSettings, PAGE_SIZE_OPTIONS, REFRESH_OPTIONS } from "./queuesSettings";
import useStyles from "./QueuesSettingsPopup.style";

interface IQueuesSettingsPopupProps {
  settings: IQueuesSettings;
  onChange: (settings: IQueuesSettings) => void;
  onClose: () => void;
}

const QueuesSettingsPopup: React.FC<IQueuesSettingsPopupProps> = ({ settings, onChange, onClose }) => {
  const classes: any = useStyles();

  const refreshLabel = (seconds: number) => {
    if (!seconds) {
      return t`Off`;
    }

    return seconds < 60 ? t`${seconds} seconds` : t`1 minute`;
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.titleText}>{t`Settings`}</Typography>
        <IconButton size="small" aria-label={t`Close`} onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormControl size="small" fullWidth>
          <InputLabel id="queues-refresh-label">{t`Refresh automatically`}</InputLabel>
          <Select
            labelId="queues-refresh-label"
            label={t`Refresh automatically`}
            value={settings.refreshSeconds}
            onChange={(event) => onChange({ ...settings, refreshSeconds: Number(event.target.value) })}
          >
            {REFRESH_OPTIONS.map((seconds) => (
              <MenuItem key={seconds} value={seconds}>
                {refreshLabel(seconds)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel id="queues-page-size-label">{t`Jobs per page`}</InputLabel>
          <Select
            labelId="queues-page-size-label"
            label={t`Jobs per page`}
            value={settings.pageSize}
            onChange={(event) => onChange({ ...settings, pageSize: Number(event.target.value) })}
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography className={classes.hint}>{t`Saved in this browser.`}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default QueuesSettingsPopup;
